/**
 * 终端api接口
 * @author： xuyd
 * @date：2024-01-01
 */
import request from "@/utils/request.js"
import {context} from '@/config/env.js'

const serviceModule = context.sunflower

export default {

  /**
   * 查询多环境配置字典
   * @param dictTypes ['ABC','DDD']
   */
  selectMultiEnvDictBatch: (dictTypes) => {
    return request.post(serviceModule + "/sys/multiEnv/dict/map/select", {ids: dictTypes});
  },

  /**
   * 终端下拉管理(全量：管理页面用，系统管理-终端管理)
   */
  searchList: (params) => {
    return request.post(serviceModule + "/sys/multiEnv/search", params);
  },

  saveGroup: (params) => {
    return request.post(serviceModule + "/sys/multiEnv/save", params);
  },
  downGroup: (id) => {
    return request.get(serviceModule + "/sys/multiEnv/down?id=" + id);
  },
  upGroup: (id) => {
    return request.get(serviceModule + "/sys/multiEnv/up?id=" + id);
  },
  deleteGroup: (id) => {
    return request.get(serviceModule + "/sys/multiEnv/delete?id=" + id);
  },

  /**
   * 修改终端的默认站点
   */
  updateDefaultSite: (id) => {
    return request.get(serviceModule + "/sys/multiEnv/site/update?id=" + id);
  },

  /**
   * 点击侧边栏，传递id查询groupId下所有站点列表
   */
  selectSiteList: (groupId) => {
    return request.get(serviceModule + "/sys/multiEnv/site/select?id=" + groupId);
  },

  /**
   * 根据站点循环，每个都调用站点参数配置列表(管理页面用，系统管理-终端管理)
   */
  searchSiteDetailList: (terminalCode, terminalSite) => {
    terminalCode = encodeURIComponent(terminalCode);
    terminalSite = encodeURIComponent(terminalSite);
    return request.get(serviceModule + `/sys/multiEnv/siteDetail/search?terminalCode=${terminalCode}&terminalSite=${terminalSite}`);
  },

  /**
   * 保存配置参数
   * @param params
   */
  saveSiteDetail: (params) => {
    return request.post(serviceModule + "/sys/multiEnv/siteDetail/save", params);
  },

  /**
   * 删除配置参数
   * @param params
   */
  deleteSiteDetail: (id) => {
    let params = {id: id};
    return request.get(serviceModule + "/sys/multiEnv/siteDetail/delete", {params});
  },

}

